import React from 'react';

interface ErrorProps {
    message: string | string[] | null;
}

const Error: React.FC<ErrorProps> = ({ message }) => {
    if (!message) return null;

    // メッセージが単一の文字列の場合は配列に変換
    const messages: string[] =
        typeof message === 'string' ? [message] : message;

    return (
        <>
            {messages.map(
                (val, index) =>
                    val && (
                        <div key={index} className="form__error">
                            <span>{val}</span>
                        </div>
                    ),
            )}
        </>
    );
};

export default Error;
